import { FEATURE_FLAGS } from 'dashboard/featureFlags';
const ConnectedBanks = () => import('./ConnectedBanks.vue');
const CorbanQueries = () => import('./CorbanQueries.vue');

export const routes = [
  {
    path: 'consultas-bancos-conectados',
    name: 'talkvia_connected_bank_queries',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: ConnectedBanks,
    featureFlag: FEATURE_FLAGS.TALKVIA_CORBAN_CLT_FGTS_QUERY,
  },
  {
    path: 'consultas-corban',
    name: 'talkvia_corban_queries',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: CorbanQueries,
  },
];
